export default __webpack_public_path__ + "static/m-sizzling1-f5d6571389c71fce32f10b304fa79d0f.jpg";